export default __webpack_public_path__ + "static/img_video-55215c007ce202d4a3a66897426129ee.jpg";